'use client'

import React from 'react'

import type { CarouselBlock as CarouselBlockProps } from '@/payload-types'
import { TextToLeftCarousel } from '../TextToLeft/Component'

type Props = CarouselBlockProps & {
  disableInnerContainer?: boolean
}

export const TextToRightCarousel: React.FC<Props> = (props) => {
  return <TextToLeftCarousel {...props} reverseLayout={true} />
}
